module.exports = "/_next/static/images/Customer@2x-111bbf6a6fe62d6c140eb883c4a674ac.webp";